import React, { useEffect, useState } from "react";
import axiosInstance from "../../utils/axiosInstance";
import "./UsersWithSOS.css";

const UsersWithSOS = () => {
  const [usersWithSOS, setUsersWithSOS] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchUsersWithSOS();
  }, []);

  const fetchUsersWithSOS = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get("/users-with-sos");
      setUsersWithSOS(res.data.usersWithSOS || []);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div className="users-sos-container">
      <h2>Users & SOS Records</h2>

      <div className="users-sos-table-wrapper">
        <table className="users-sos-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Emergency Contact 1</th>
              <th>Emergency Contact 2</th>
              <th>SOS Type</th>
              <th>Location</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            {usersWithSOS.map(({ user, sosRecords }) => {
              const contact1 = `${user.emergencyContact1?.name || "-"}: ${user.emergencyContact1?.phone || "-"}`;
              const contact2 = user.emergencyContact2
                ? `${user.emergencyContact2.name || "-"}: ${user.emergencyContact2.phone || "-"}`
                : "-";

              if (sosRecords.length === 0) {
                return (
                  <tr key={user._id}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.mobile}</td>
                    <td>{contact1}</td>
                    <td>{contact2}</td>
                    <td colSpan={3} style={{ textAlign: "center" }}>
                      No SOS sent
                    </td>
                  </tr>
                );
              }

              return sosRecords.map((sos, index) => {
                const mapLink = `https://www.google.com/maps?q=${sos.latitude},${sos.longitude}`;
                return (
                  <tr key={sos._id}>
                    {index === 0 && (
                      <>
                        <td rowSpan={sosRecords.length}>{user.name}</td>
                        <td rowSpan={sosRecords.length}>{user.email}</td>
                        <td rowSpan={sosRecords.length}>{user.mobile}</td>
                        <td rowSpan={sosRecords.length}>{contact1}</td>
                        <td rowSpan={sosRecords.length}>{contact2}</td>
                      </>
                    )}
                    <td>{sos.emergencyType}</td>
                    <td>
                      <a href={mapLink} target="_blank" rel="noopener noreferrer">
                        {sos.latitude}, {sos.longitude}
                      </a>
                    </td>
                    <td>{new Date(sos.createdAt).toLocaleString()}</td>
                  </tr>
                );
              });
            })}
          </tbody>
        </table>
      </div>

      {/* Mobile card layout */}
      <div className="users-sos-cards">
        {usersWithSOS.map(({ user, sosRecords }) => {
          const contact1 = `${user.emergencyContact1?.name || "-"}: ${user.emergencyContact1?.phone || "-"}`;
          const contact2 = user.emergencyContact2
            ? `${user.emergencyContact2.name || "-"}: ${user.emergencyContact2.phone || "-"}`
            : "-";

          if (sosRecords.length === 0) {
            return (
              <div className="user-card" key={user._id}>
                <h3>{user.name}</h3>
                <p><strong>Email:</strong> {user.email}</p>
                <p><strong>Mobile:</strong> {user.mobile}</p>
                <p><strong>Contact 1:</strong> {contact1}</p>
                <p><strong>Contact 2:</strong> {contact2}</p>
                <p style={{ textAlign: "center", color: "#555" }}>No SOS sent</p>
              </div>
            );
          }

          return sosRecords.map((sos) => {
            const mapLink = `https://www.google.com/maps?q=${sos.latitude},${sos.longitude}`;
            return (
              <div className="user-card" key={sos._id}>
                <h3>{user.name}</h3>
                <p><strong>Email:</strong> {user.email}</p>
                <p><strong>Mobile:</strong> {user.mobile}</p>
                <p><strong>Contact 1:</strong> {contact1}</p>
                <p><strong>Contact 2:</strong> {contact2}</p>
                <p><strong>SOS Type:</strong> {sos.emergencyType}</p>
                <p>
                  <strong>Location:</strong>{" "}
                  <a href={mapLink} target="_blank" rel="noopener noreferrer">
                    {sos.latitude}, {sos.longitude}
                  </a>
                </p>
                <p><strong>Time:</strong> {new Date(sos.createdAt).toLocaleString()}</p>
              </div>
            );
          });
        })}
      </div>
    </div>
  );
};

export default UsersWithSOS;
